import {planTypes} from "@/common/constants";

export default {
  data () {
    return {
      logo: require('@/assets/plans/logo_custom_avatars.svg'),
      title: this.$t('billing.custom_avatars.title'),
      planType: planTypes.CUSTOM_AVATARS,
    }
  }
};
